$(function() {
// Auto refresh live-game section if it exists
    refreshBetslip();
    setInterval(refreshBetslip, 60000);
    if($("#avg-odds").length > 0){
        var cols = []
        var trs = $('#avg-odds tr')
        var data =$.each(trs , function(index, tr){
            $.each($(tr).find("td").not(":first"), function(index, td){
                cols[index] = cols[index] || [];
                cols[index].push($(td).text())
            })
        });
        cols.forEach(function(col, index){
            var max = Math.max.apply(null, col);
            var min = Math.min.apply(null, col)
            $('#avg-odds tr').find('td:eq('+(index+1)+')').each(function(i, td){
                $(td).toggleClass('best_odds', +$(td).text() === max)
                //$(td).toggleClass('min', +$(td).text() === min)
            })
        })
    }

    $(".btn-bs-change").click(function () {
        for (i = 1; i <= 13; i++) {
            $(".pos_" + i).parents().find(".bs_np").show();
            $(".pos_" + i).parents().find(".bs_result_parent_go").hide();
            $(".pos_" + i).parents().find(".bs_prediction_go").hide();
        }
    });

    $(document).on('click', '.bsid-more', function () {
        var selector = "[data-card-id=\"" + $(this).data("target") + "\"]";
        $(selector).toggleClass("flipped");
        return false;
    });

    $(document).on('click', '.bs-filter-heading', function () {
        $(".qf-wrapper").slideToggle("fast");
    });

    $(document).on('click', '.bs-close-card', function () {
        var selector = "[data-card-id=\"" + $(this).data("target") + "\"]";
        $(selector).toggleClass("flipped");
        return false;
    });


    if ($(".siema").length > 0) {
        if ($(".qf-nav").css("display") == "block") {
            var siema = new Siema({
                perPage: 2,
                loop: true,
                duration: 200,
                easing: 'ease-out',
            });
        }
    }

    $(window).resize(function () {
        if ($(".siema").length > 0) {
            if ($(".md-positives").is(":visible")) {
                if (siema != undefined) {
                    siema.destroy(true);
                }
            } else {
                if (siema == undefined) {
                    var siema = new Siema({
                        perPage: 2,
                        loop: true,
                        duration: 200,
                        easing: 'ease-out',
                    });
                }
            }
        }
    });

    $(document).on("click", ".qf-nav-prev a", function () {
        siema.prev();
    });

    $(document).on("click", ".qf-nav-next a", function () {
        siema.next();
    });

    $(document).on('click', '.quick-filter', function () {
        $('.quick-filter').not($(this)).removeClass("qf-active");
        $(this).toggleClass("qf-active");

        var field = $(this).data("field");
        if ($(this).hasClass("qf-active")) {
            var active = 1;
        } else {
            var active = 0;
        }

        $.post(
            ajaxUrl + "/ajax/getBettingsidorNew.php",
            {
                field: field,
                active: active
            },
            function (data) {
                var result2 = $.parseJSON(data);
                if (result2.success == true) {
                    $("#betsid").html(result2.data);
                }
            }
        );
        return false;
    });

    $(document).on('click', '.bs_fixture_expand', function () {
        $(this).find("i").removeClass("fa-angle-down").addClass("fa-angle-up");
        var selector = "[data-id=\"" + $(this).data("target") + "\"]";
        if ($(selector).is(":visible")) {
            $(".betslip_fixture_additional").hide();
            $(this).find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        } else {
            if ($(this).data("content-loaded") == 0) {
                var base_el = $(this);
                $.get(
                    ajaxUrl + "/ajax/getExtendedBetslipData.php",
                    {
                        match_id: $(this).data("target"),
                    },
                    function (data) {
                        var result = $.parseJSON(data);
                        if (result.success == true) {
                            $(selector).html(result.data);
                            base_el.data("content-loaded", 1);
                        }
                    }
                );
            }
            $('.bs_fixture_expand').not($(this)).find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            $(".betslip_fixture_additional").hide();
            $(selector).fadeToggle();
        }
        return false;
    });

    $(document).on('click', '.svs-sugg-stats', function () {
        var selector = "[data-id=\"" + $(this).data("target") + "\"]";
        console.log(selector);
        if ($(selector).is(":visible")) {
            $(".betslip_fixture_additional").hide();
            $(this).find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
        } else {
            if ($(this).data("content-loaded") == 0) {
                var base_el = $(this);
                $.get(
                    ajaxUrl + "/ajax/getExtendedBetslipDataSvs.php",
                    {
                        match_id: $(this).data("target"),
                    },
                    function (data) {
                        var result = $.parseJSON(data);
                        if (result.success == true) {
                            $(selector).html(result.data);
                            base_el.data("content-loaded", 1);
                        }
                    }
                );
            }
            $('.bs_fixture_expand').not($(this)).find("i").removeClass("fa-angle-up").addClass("fa-angle-down");
            $(".betslip_fixture_additional").hide();
            $(".row-content").slideUp("fast");
            $(selector).fadeToggle();
        }
        return false;
    });

    $(document).on("click", ".btn-row-content", function () {
        $(".betslip_fixture_additional").slideUp("fast");
        $(".row-content").slideUp("fast");
        if (!$("#" + $(this).data("target")).is(":visible")) {
            $("#" + $(this).data("target")).slideDown("fast");
        }
        return;
    });

    $(document).on("click", ".load-more-bs", function () {
        var i = 0;
        $(".bm-hidden").each(function () {
            if (i <= 9) {
                $(this).fadeIn().removeClass("bm-hidden");
            }
            i++;
        });
        if ($(".bm-hidden").length == 0) {
            $(".load-more-bs").fadeOut();
        }
        return false;
    });

    $(document).on('click', '.betslip_nav', function () {
        var id = $(this).data("id");
        var product_id = $(this).data("product-id");

        if (id === "") {
            if ($(this).data("direction") == "next") {
                alert("Det finns inga nyare kuponger")
            } else {
                alert("Det finns inga äldre kuponger")
            }
            return false;
        }

        $.get(
            ajaxUrl + "/ajax/getBetslip.php",
            {
                id: id,
                product_id: product_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    $("#svs_tips_wrapper").html(result.data);
                    refreshBetslip();
                }
            }
        );
        return false;
    });

    $(document).on('click', '.svs_save', function () {
        var pos = 0;
        var str = "";
        $(".svs-info-link").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("svs_disabled");
                if ($(this).data("pos") != pos) {
                    str += ",";
                    pos = $(this).data("pos");
                }
                str += $(this).text();
                $(this).addClass("locked");
            } else {
                $(this).addClass("svs_disabled");
            }
        });
        var drawnumber = $("#drawnumber").val();
        localStorage.setItem(drawnumber, str);
    });

    $(document).on('click', '.svs_disabled', function () {
        $(this).removeClass("selected");
        return false;
    });

    $(document).on('click', '.locked', function () {
        $(this).addClass("selected");
        $(this).click();
    });

    if ($(".odds-fixture-placeholder").length > 0) {
        updateOddsList('3way');
    }

});

function refreshBetslip(){
    return false;
    if($(".svs-tipset-wrapper").length > 0){
        if($(".svs-tipset-wrapper").data("live") == 1){
            printBetslipStatus();
            updateBetslipRows();
        }
    }
}

function printBetslipStatus(){
    var drawnumber = $("#drawnumber").val();
    $.get(
        ajaxUrl+"/ajax/refreshBetslip.php",
        {
            action : "status",
            drawnumber : drawnumber
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                if(result.data == "LIVE"){
                    $(".svs_live_status").html("Kupongen är live!");
                } else if(result.data == "FT"){
                    $(".svs_live_status").html("Matcherna är slut");
                } else {
                    $(".svs_live_status").html("Matcherna har ej startat");
                }
                $(".svs_live_status").fadeIn();
            }
        }
    );
}

$(document).on("click", ".odds-page-tabs > ul > li > a", function(e){
    e.preventDefault();
    var odds_type = $(this).data("odds-type");
    $("#odds-page-type").val(odds_type);
    var label = $(this).data("label");
    $('.odds-page-tabs > ul > li').removeClass('active');
    $(".fixture-row-top-right-odds-list").addClass('hidden');
    $(".fixture-row-top-right-odds-list[data-row-type='" + odds_type + "']").removeClass('hidden');
    $(this).parent().addClass('active');

    if(odds_type == "over_under" || odds_type == "corners_over_under") {
        var fillDropdown = 1;
        $('.odds-page-sub-tabs').show();
    } else {
        var fillDropdown = 0;
        $('.odds-page-sub-tabs').hide();
    }

    if($("#show-odds-type").is(":visible")){
        $("#show-odds-type").text($(this).data("title"));
    }

    $(".odds-sub-tabs > ul > li > a").each(function(){
        $(this).data("odds-type", odds_type);
    });


    updateOddsList(odds_type, fillDropdown, label);
});
$(document).on("change", "odds-page-sub-tabs > ul > li > select", function(e){
    console.log($(this).val());
});

function updateOddsList(type, dropdown = 0, label = ""){
    $(".odds-fixture-placeholder").each(function(i){
        var parent = $(this);
        var match_id = $(this).data("match-id");
        $.get(
            ajaxUrl+"/ajax/getOddsPerMatch.php",
            {
                match_id : match_id,
                type : type,
                label : label,
                dropdown : dropdown
            },
            function(data){
                var result = $.parseJSON(data);
                if (result.success === true) {
                    Object.keys(result.data).forEach(key => {
                        parent.find(`[data-odds='${key}']`).text(result.data[key]);
                    });
                    $(".odds-fixture-placeholder-market").addClass('hidden');
                    $(".odds-fixture-placeholder-market[data-market-type='" + type + "']").removeClass('hidden');
                    if(result.dropdown != ""){
                        $(".odds-page-sub-tabs > ul > li > select").html(result.dropdown);
                        $(".odds-page-sub-tabs > ul > li > select").show();
                        $(".odds-page-sub-tabs > ul > li > select").select2({
                            minimumResultsForSearch: -1
                        });
                    } else {
                        $(".odds-page-sub-tabs > ul > li > select").hide();
                    }
                }
            }
        )
    });
}

function updateBetslipRows(){
    return false;
    var drawnumber = $("#drawnumber").val();
}